/* eslint-disable @typescript-eslint/no-confusing-void-expression */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import {
  DownloadOutlined,
  DownOutlined,
  RightOutlined,
} from "@ant-design/icons";
import { List } from "antd";
import {
  type InstanceLogsType,
  type InstanceLogsTabProps,
} from "../redux/slices/midservice/midserviceTypes";
import React, { useEffect, useRef, useState } from "react";
import { getApiUrl } from "../utils/url";
import Title from "antd/lib/typography/Title";
import Text from "antd/lib/typography/Text";

interface LogsViewWithTitleProps {
  title: string;
  logs: InstanceLogsType[];
}

export const LogsViewWithTitle = ({
  title,
  logs,
}: LogsViewWithTitleProps): JSX.Element => {
  const [open, setOpen] = useState(true);
  const innerRef = useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState<number>(0);

  useEffect(() => {
    if (innerRef.current) {
      setHeight(innerRef.current.scrollHeight);
    }
  }, [logs]);

  const DURATION_PER_PX = 0.0008;
  const MIN_DURATION = 0.3;
  const MAX_DURATION = 1.2;
  const duration = Math.min(
    Math.max(height * DURATION_PER_PX, MIN_DURATION),
    MAX_DURATION,
  );

  return (
    <div>
      <Title
        level={5}
        onClick={() => setOpen((prev) => !prev)}
        style={{ cursor: "pointer", userSelect: "none" }}
      >
        {title} {open ? <DownOutlined /> : <RightOutlined />}
      </Title>
      <div
        style={{
          height: open ? height : 0,
          overflow: "hidden",
          transition: `height ${duration}s ease`,
        }}
      >
        <div ref={innerRef}>
          {logs?.length > 0 ? (
            <LogsView logs={logs} />
          ) : (
            <Text>Логи отсутствуют</Text>
          )}
        </div>
      </div>
    </div>
  );
};

export const LogsView = ({ logs }: InstanceLogsTabProps): JSX.Element => {
  return (
    <List
      className="demo-loadmore-list"
      itemLayout="horizontal"
      dataSource={logs}
      renderItem={(item) => (
        <List.Item
          actions={[
            <a
              target="_blank"
              href={`${getApiUrl()}${item.archiveUrl}`}
              key="list-loadmore-edit"
              rel="noreferrer"
            >
              Скачать <DownloadOutlined />
            </a>,
          ]}
        >
          <List.Item.Meta
            title={
              <a
                target="_blank"
                href={`${getApiUrl()}${item.archiveUrl}`}
                key="list-loadmore-edit"
                rel="noreferrer"
              >
                {item.name}
              </a>
            }
          />
        </List.Item>
      )}
    />
  );
};
